import { fetchCompanyClients } from '@/api/v4/organization-clients.api';
import { fetchSpotlightCompanyClients } from '@/api/v4/spotlight.api';
import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';
import { companyIdState } from '../company.state';
import { useAtomValue } from 'jotai';
import {
  type CompanyFetchMode,
  useCompanyFetchMode,
} from '../company-fetch-context';

const companyClientsFetchers: Record<
  CompanyFetchMode,
  (companyId: string) => ReturnType<typeof fetchCompanyClients>
> = {
  general: fetchCompanyClients,
  spotlight: fetchSpotlightCompanyClients,
};

export const useCompanyClients = (companyIdParam?: string) => {
  const companyOverviewId = useAtomValue(companyIdState);
  const companyId = companyIdParam || companyOverviewId;
  const fetchMode = useCompanyFetchMode();

  return useQuery({
    queryKey: [QueryKey.CompanyClients, fetchMode, companyId],
    queryFn: () => {
      if (!companyId) return null;
      return companyClientsFetchers[fetchMode](companyId);
    },
    enabled: !!companyId,
  });
};
